import getApi from "../api/getApi";
import postApi from "../api/postApi";
import * as url from "../api/url";

export const getAssetType = (header) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_ASSET_TYPES, header)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getAssetStatuses = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_ASSET_STATUSES, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getAssetIcon = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_ASSET_ICON, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getAssetMake = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_ASSET_MAKE, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addAsset = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.ADD_ASSET, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const uploadBulkImg = (payload, header, query, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.UPLOAD_IMG}?${query}`, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const GetPictureByContext = (query, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_PICTURES}?${query}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const savePicture = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.SAVE_PICTURE}`, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addAssetAdvertisements = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.SAVE_ASSET_ADVERTISEMENTS}`, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addAssetAdvertisementsImg = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.SAVE_ASSET_ADVERTISEMENTS_IMG}`, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addWatchList = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.ADD_WATCH_LIST}`, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getContactById = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_CONTACT}?${payload}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addLocation = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.ADD_LOCATION, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const checkUnitNumber = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.UNIT_SERIAL_NUM_VALIDATION}?${payload}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getLocations = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_LOCATION}?${payload}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getAssetByID = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_ASSET_BY_ID}?${payload}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
export const getAssetAdvByID = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_ASSET_ADVERTISEMENTS_BY_ASSET_ID}?${payload}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getExtraDataSchema = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_EXTRA_DATA_SCHEMA}?${payload}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getExtraData = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_EXTRA_DATA}?${payload}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const saveExtra = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.SAVE_EXTRA_DATA}`, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const setAsMainPicture = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.SET_MAIN_PICTURE}?${payload}`, null, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getCompanyByString = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.GET_COMPANIES, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addCategori = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.SAVE_ASSET_CATEGORI, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
